import { useMemo, useState } from "react";
import FinalistCard from "@/components/feature/FinalistCard";
import { finalists } from "@/mocks/finalists";
import { categories } from "@/mocks/categories";

export default function FinalistsExplorer() {
  const [activeCategory, setActiveCategory] = useState("all");
  const [query, setQuery] = useState("");

  const results = useMemo(() => {
    const keyword = query.trim().toLowerCase();
    return finalists.filter((item) => {
      const matchCategory = activeCategory === "all" || item.category === activeCategory;
      const matchKeyword =
        keyword === "" ||
        item.title.toLowerCase().includes(keyword) ||
        item.summary.toLowerCase().includes(keyword) ||
        item.tags.some((tag) => tag.toLowerCase().includes(keyword));
      return matchCategory && matchKeyword;
    });
  }, [activeCategory, query]);

  return (
    <section className="bg-background-50 pb-16 md:pb-24">
      <div className="w-full px-4 md:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5 py-6 border-b border-background-200">
            <div className="flex flex-wrap gap-1.5 p-1 rounded-full bg-background-100 w-fit">
              {categories.map((cat) => {
                const isActive = activeCategory === cat.id;
                return (
                  <button
                    key={cat.id}
                    type="button"
                    onClick={() => setActiveCategory(cat.id)}
                    className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                      isActive
                        ? "bg-primary-500 text-background-50 font-medium"
                        : "text-foreground-700 hover:text-primary-600"
                    }`}
                  >
                    {cat.name}
                  </button>
                );
              })}
            </div>

            <div className="relative w-full lg:w-72">
              <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-base" />
              <input
                type="search"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜索作品标题或标签"
                aria-label="搜索入围作品"
                className="w-full pl-10 pr-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
              />
            </div>
          </div>

          <p className="mt-6 text-sm text-foreground-600">
            共找到 <strong className="text-foreground-950">{results.length}</strong> 件入围作品
            {activeCategory !== "all" && ` · ${categories.find((c) => c.id === activeCategory)?.name}`}
          </p>

          {results.length > 0 ? (
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {results.map((item) => (
                <FinalistCard key={item.id} item={item} />
              ))}
            </div>
          ) : (
            <div className="mt-10 py-16 text-center border border-dashed border-background-300 rounded-lg">
              <span className="w-14 h-14 mx-auto rounded-full bg-background-100 text-foreground-400 flex items-center justify-center text-2xl mb-4">
                <i className="ri-search-eye-line" />
              </span>
              <p className="text-foreground-800 font-medium">没有找到匹配的入围作品</p>
              <p className="mt-1 text-sm text-foreground-500">换个关键词，或切换到「全部」分类再看看。</p>
              <button
                type="button"
                onClick={() => {
                  setQuery("");
                  setActiveCategory("all");
                }}
                className="mt-5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                重置筛选条件
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}